import React, { useEffect, useState } from 'react';
import { t, Trans } from '@lingui/macro';
import { useParams } from 'react-router-dom';
import { Button, LinearProgress } from '@material-ui/core';
import NetTestNowTestResultsPanel from '../../panels/net-test-now-panels/NetTestNowTestResultsPanel';
import { Actions, Page, PageHeader, PanelContainer } from '../../page-framework';
import { useNavigate } from '../../../utilities/PgmUtilities';
import ReportAction from '../../page-framework/actions/ReportAction';
import useBreadcrumb from '../../breadcrumb/UseBreadcrumb';
import { useDataService } from '../../../services/ApiDataService';
import { useIntervalRefreshTrigger } from '../../data-table/Triggers';
import { NetTestNowIsLoadingConsumer, NetTestNowIsLoadingProvider } from './NetTestNowIsLoadingContext';

export const pageId = 'net-test-now';

export default function NetTestNowResultsPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const handleReRunTest = () => {
        navigate('/net-test-now', { state: { isDetailsPanel: true, testSelection: id } });
    };
    const [testName, setTestName] = useState();
    const [netTestNowIsLoading, setNetTestNowIsLoading] = useState(false);
    const dataService = useDataService();
    const goToUrl = '/net-test-now';
    const apiUrl = '/ipm/v1/admin/quicktests';
    const functionBreadCrumbs = [{ link: goToUrl, text: t`Bandwidth Test Now` }];
    const reportingLinkConfig = {
        target: '/net-test-now',
    };
    const { triggerRef } = useIntervalRefreshTrigger({
        interval: 20000,
    });

    useEffect(() => {
        (async () => {
            const quickTests = await dataService.get(apiUrl);
            const { name } = quickTests?.filter((test) => test._id === id).pop();
            setTestName(name);
        })();
    }, [dataService, id]);

    const breadcrumbs = useBreadcrumb(functionBreadCrumbs, null, {}, 'name', `${testName || 'Test Result'}`, {
        reportingLinkConfig,
    });

    return (
        <Page id={pageId}>
            <NetTestNowIsLoadingProvider value={[netTestNowIsLoading, setNetTestNowIsLoading]}>
                <PageHeader
                    title={t`Bandwidth Test Now Result`}
                    breadcrumbs={breadcrumbs}
                    actions={
                        <Actions>
                            <Button onClick={handleReRunTest}>
                                <Trans>Re-Run</Trans>
                            </Button>
                            <ReportAction
                                pageId={pageId}
                                pageTitle={t`Bandwidth Test Now Result`}
                                options={{ canSchedule: false }}
                                tooltipPlacement="bottom"
                            />
                        </Actions>
                    }
                />
                <NetTestNowIsLoadingConsumer>
                    {([testNowQueryIsLoading]) => <>{testNowQueryIsLoading && <LinearProgress color="secondary" />}</>}
                </NetTestNowIsLoadingConsumer>
                <PanelContainer flexHeight>
                    <NetTestNowTestResultsPanel id={id} hideTitle triggerRef={triggerRef} />
                </PanelContainer>
            </NetTestNowIsLoadingProvider>
        </Page>
    );
}
